"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Slider = _interopRequireDefault(require("../../../common/Slider"));

var _Icon = _interopRequireDefault(require("../../../common/Icon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _components = _interopRequireDefault(require("../../../styles/components"));

var _connectToMedia = _interopRequireDefault(require("../../Media/connectToMedia"));

var _TimeLabel = _interopRequireDefault(require("../../Labels/TimeLabel"));

var _lodash = require("lodash");

var _Badge = _interopRequireDefault(require("../../../common/Badge"));

var _Button = _interopRequireDefault(require("../../../common/Button"));

var _ToolTip = _interopRequireDefault(require("../../../common/ToolTip"));

var _circle = _interopRequireDefault(require("../../../assets/icons/circle.gif"));

var _VoicebaseReactPlayerContext = _interopRequireDefault(require("../../../VoicebaseReactPlayerContext"));

var _playNextPreviousMedia = _interopRequireDefault(require("../utils/playNextPreviousMedia"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var mapStateToProps = function mapStateToProps(state) {
  return _extends({}, state.media, {
    queries: state.query
  });
};

var ProgressSpeed = [1, 1.25, 1.5, 1.75, 2];

var ProgressControls = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(ProgressControls, _React$PureComponent);

  function ProgressControls(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "seek", function (value) {
      var _this$props = _this.props,
          onSeek = _this$props.onSeek,
          duration = _this$props.duration;
      onSeek({
        s: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getHitMarks", (0, _memoizeOne["default"])(function (queries) {
      var _ref;

      return (_ref = []).concat.apply(_ref, queries.map(function (query) {
        return query.hits;
      })).reduce(function (acc, hit) {
        var _extends2;

        return _extends({}, acc, (_extends2 = {}, _extends2[(0, _lodash.get)(hit, "s", [])] = /*#__PURE__*/_react["default"].createElement(_components["default"].ProgressMark, null), _extends2));
      }, {});
    }));

    _defineProperty(_assertThisInitialized(_this), "play", function () {
      var onPlay = _this.props.onPlay;

      _this.setState({
        onHoverPlay: true
      });

      onPlay();
    });

    _defineProperty(_assertThisInitialized(_this), "pause", function () {
      var onPause = _this.props.onPause;
      onPause();
    });

    _defineProperty(_assertThisInitialized(_this), "skipForward", function () {
      var _this$props2 = _this.props,
          onSeek = _this$props2.onSeek,
          duration = _this$props2.duration,
          currentTime = _this$props2.currentTime;
      var skipTime = currentTime + 15000; // currentTime + (duration / 20);

      onSeek({
        s: skipTime > duration ? duration : skipTime
      });
    });

    _defineProperty(_assertThisInitialized(_this), "skipBackward", function () {
      var _this$props3 = _this.props,
          onSeek = _this$props3.onSeek,
          duration = _this$props3.duration,
          currentTime = _this$props3.currentTime;
      var skipTime = currentTime - 15000; // currentTime - (duration / 20);

      onSeek({
        s: skipTime < 0 ? 0 : skipTime
      });
    });

    _defineProperty(_assertThisInitialized(_this), "skipToStart", function () {
      var onSeek = _this.props.onSeek;
      onSeek({
        s: 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "skipToEnd", function () {
      var _this$props4 = _this.props,
          onSeek = _this$props4.onSeek,
          duration = _this$props4.duration;
      onSeek({
        s: duration
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addWordSearchedClass", function (i) {
      if (document.querySelector(".word-index-" + i)) {
        document.querySelector(".word-index-" + i).classList.add("word-searched");
      }
    });

    _defineProperty(_assertThisInitialized(_this), "removeWordSearchedClass", function () {
      var allElements = document.querySelectorAll(".word-searched");
      allElements.forEach(function (element) {
        element.classList.remove("word-searched");
      });
    });

    _defineProperty(_assertThisInitialized(_this), "skipToNextHit", function (event) {
      var _this$props5 = _this.props,
          queries = _this$props5.queries,
          currentTime = _this$props5.currentTime,
          currentPosition = _this$props5.currentPosition,
          onSeek = _this$props5.onSeek,
          onSkipPrevNextHit = _this$props5.onSkipPrevNextHit;

      var hits = _this.getHits(queries);

      var hit = hits.find(function (hit) {
        if (hit.s) {
          return hit.s > Math.ceil(currentTime);
        }

        return hit.p > Math.ceil(currentPosition);
      }) || hits[0];

      if (hit) {
        onSeek(hit);
        onSkipPrevNextHit(true);

        _this.removeWordSearchedClass();

        _this.addWordSearchedClass(hit.p);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "changeVolume", function (value) {
      var onVolume = _this.props.onVolume;
      onVolume(value / 100);
    });

    _defineProperty(_assertThisInitialized(_this), "clickOnVolume", function () {
      var _this$props6 = _this.props,
          onVolume = _this$props6.onVolume,
          volume = _this$props6.volume;

      if (volume > 0) {
        onVolume(0 / 100);
      } else {
        onVolume(50 / 100);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getHits", (0, _memoizeOne["default"])(function (queries) {
      var _ref2;

      return (_ref2 = []).concat.apply(_ref2, queries.map(function (query) {
        return query.hits;
      })).sort(function (a, b) {
        return a.s - b.s;
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "onVisibleChangeForSelectSpeedTooltip", function (isSpeedTooltipVisible) {
      _this.setState({
        isSpeedTooltipVisible: isSpeedTooltipVisible
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setPlaybackSpeed", function (speed) {
      var onPlaybackSpeedChange = _this.props.onPlaybackSpeedChange;

      _this.setSpeedValue(speed);

      onPlaybackSpeedChange(speed);
    });

    _this.state = {
      isSpeedTooltipVisible: false,
      speedValue: 1,
      skipBackColor: "#677791",
      skipForwardColor: "#677791",
      backColor: "#677791",
      nextColor: "#677791",
      onHoverPlay: true
    };
    return _this;
  }

  var _proto = ProgressControls.prototype;

  _proto.renderTooltip = function renderTooltip(value) {
    return /*#__PURE__*/_react["default"].createElement(_TimeLabel["default"], {
      ms: value
    });
  };

  _proto.setProgressControlIcon = function setProgressControlIcon(name) {
    switch (name) {
      case "Play":
        return /*#__PURE__*/_react["default"].createElement("svg", {
          width: "62",
          height: "62",
          viewBox: "0 0 62 62",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/_react["default"].createElement("path", {
          d: "M31 54.25C43.8406 54.25 54.25 43.8406 54.25 31C54.25 18.1594 43.8406 7.75 31 7.75C18.1594 7.75 7.75 18.1594 7.75 31C7.75 43.8406 18.1594 54.25 31 54.25Z",
          fill: "#339EEC",
          stroke: "#339EEC",
          strokeWidth: "2",
          strokeMiterlimit: "10"
        }), /*#__PURE__*/_react["default"].createElement("path", {
          d: "M38.75 31L27.125 23.25V38.75L38.75 31Z",
          fill: "white",
          stroke: "white",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }));

      default:
        break;
    }
  };

  _proto.setSpeedValue = function setSpeedValue(speed) {
    this.setState({
      speedValue: speed
    });
  };

  _proto.selectedSpeed = function selectedSpeed() {
    var _this2 = this;

    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: "grid"
      },
      className: "player-speed"
    }, ProgressSpeed.map(function (speed) {
      return /*#__PURE__*/_react["default"].createElement(_components["default"].ProgressSpeedButton, {
        onClick: function onClick() {
          return _this2.setPlaybackSpeed(speed);
        },
        active: speed === _this2.state.speedValue
      }, speed);
    }));
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props7 = this.props,
        _this$props7$currentT = _this$props7.currentTime,
        currentTime = _this$props7$currentT === void 0 ? 0 : _this$props7$currentT,
        _this$props7$duration = _this$props7.duration,
        duration = _this$props7$duration === void 0 ? 0 : _this$props7$duration,
        mediaId = _this$props7.mediaId,
        queries = _this$props7.queries,
        readyState = _this$props7.readyState,
        volume = _this$props7.volume,
        paused = _this$props7.paused,
        isTimeLineVisible = _this$props7.isTimeLineVisible,
        setTimelineVisibility = _this$props7.setTimelineVisibility,
        playbackRate = _this$props7.playbackRate,
        isChatTextMedia = _this$props7.isChatTextMedia,
        messagesDuration = _this$props7.messagesDuration;
    var _this$context$isHoste = this.context.isHostedApp,
        isHostedApp = _this$context$isHoste === void 0 ? false : _this$context$isHoste;
    var hitCount = queries.reduce(function (acc, query) {
      return (0, _lodash.get)(query, "hits.length", 0) + acc;
    }, 0);
    var loading = readyState < 2;

    var previousNextButtons = function previousNextButtons(style) {
      if (style === void 0) {
        style = {};
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        style: _extends({}, style, {
          display: "flex"
        })
      }, /*#__PURE__*/_react["default"].createElement(_components["default"].ProgressIconStyle, null, /*#__PURE__*/_react["default"].createElement(_ToolTip["default"], {
        key: "Previous",
        placement: "bottom",
        trigger: ["hover"],
        overlay: /*#__PURE__*/_react["default"].createElement("span", null, "Previous"),
        style: {
          minHeight: "auto"
        }
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        onMouseOver: function onMouseOver() {
          return _this3.setState({
            backColor: "#262D38"
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this3.setState({
            backColor: "#677791"
          });
        },
        onClick: function onClick() {
          (0, _playNextPreviousMedia["default"])(_extends({}, _this3.context, {
            mediaId: mediaId,
            nextOrPrevious: "previous"
          }));
        }
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M14.5 8.64697L4.5 8.64697",
        stroke: _this3.state.backColor,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "demo1"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M9.00049 4.14697L4.50049 8.64697L9.00049 13.147",
        stroke: _this3.state.backColor,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "demo1"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M2.5 3.64697L2.5 13.647",
        stroke: _this3.state.backColor,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "demo1"
      })))), /*#__PURE__*/_react["default"].createElement(_components["default"].ProgressIconStyle, null, /*#__PURE__*/_react["default"].createElement(_ToolTip["default"], {
        key: "Next",
        placement: "bottom",
        trigger: ["hover"],
        overlay: /*#__PURE__*/_react["default"].createElement("span", null, "Next"),
        style: {
          minHeight: "auto"
        }
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        onMouseOver: function onMouseOver() {
          return _this3.setState({
            nextColor: "#262D38"
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this3.setState({
            nextColor: "#677791"
          });
        },
        onClick: function onClick() {
          (0, _playNextPreviousMedia["default"])(_extends({}, _this3.context, {
            mediaId: mediaId,
            nextOrPrevious: "next"
          }));
        }
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M1.5 8.64697H11.5",
        stroke: _this3.state.nextColor,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M6.99951 13.147L11.4995 8.64697L6.99951 4.14697",
        stroke: _this3.state.nextColor,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M13.5 13.647V3.64697",
        stroke: _this3.state.nextColor,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })))));
    };

    return isChatTextMedia ? /*#__PURE__*/_react["default"].createElement(_components["default"].Progress, null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: "flex",
        flexDirection: "column"
      }
    }, !isHostedApp && previousNextButtons({
      alignSelf: "flex-end",
      margin: "1rem"
    }), /*#__PURE__*/_react["default"].createElement(_components["default"].ProgressIconStyle, {
      style: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginLeft: "unset" // textAlign: "right",

      }
    }, /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
      disabled: isChatTextMedia,
      horizontal: true,
      min: 0,
      max: messagesDuration,
      marks: this.getHitMarks(queries),
      value: currentTime,
      tipFormatter: this.renderTooltip,
      onChange: this.seek // TODO: use a method call
      ,
      style: {
        margin: 5,
        flex: 1
      },
      dotStyle: {
        display: "none"
      }
    }), /*#__PURE__*/_react["default"].createElement(_ToolTip["default"], {
      key: "Skip to Next",
      placement: "bottom",
      trigger: ["hover"],
      overlay: /*#__PURE__*/_react["default"].createElement("span", null, "Skip to Next Hit"),
      style: {
        minHeight: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      "class": "next-hit-button-container messages-player"
    }, this.getHits(queries).length ? /*#__PURE__*/_react["default"].createElement(_Badge["default"], {
      dot: true
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      onClick: this.skipToNextHit,
      shape: "circle",
      icon: "history",
      size: "sm"
    })) : /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      shape: "circle",
      icon: "history",
      disabled: true,
      size: "sm"
    }))), /*#__PURE__*/_react["default"].createElement(_ToolTip["default"] // placement="left"
    , {
      trigger: ["hover"],
      overlay: /*#__PURE__*/_react["default"].createElement("span", null, "Toggle speaker sentiment timeline"),
      style: {
        minHeight: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      shape: "circle",
      size: "sm",
      onClick: function onClick() {
        return setTimelineVisibility();
      },
      icon: isTimeLineVisible ? "up" : "down",
      style: {
        border: "2px solid #677791"
      }
    }))))) : /*#__PURE__*/_react["default"].createElement(_components["default"].Progress, null, /*#__PURE__*/_react["default"].createElement(_components["default"].ProgressControl, null, /*#__PURE__*/_react["default"].createElement(_components["default"].ProgressIcon, {
      style: {
        minHeight: "60px",
        minWidth: "65px"
      }
    }, paused ? /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        minWidth: "65px"
      }
    }, /*#__PURE__*/_react["default"].createElement(_ToolTip["default"], {
      key: "Play",
      placement: "bottom",
      trigger: ["hover"],
      overlay: /*#__PURE__*/_react["default"].createElement("span", null, "Play"),
      style: {
        minHeight: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      type: "primary",
      onClick: this.play,
      loading: loading,
      disabled: loading,
      shape: "circle",
      size: "lg",
      icon: "caret-right",
      style: {
        marginTop: "5px"
      }
    }))) : /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        marginRight: "10px",
        cursor: "pointer",
        minWidth: "65px"
      }
    }, this.state.onHoverPlay ? /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_ToolTip["default"], {
      key: "Pause",
      placement: "bottom",
      trigger: ["hover"],
      overlay: /*#__PURE__*/_react["default"].createElement("span", null, "Pause"),
      style: {
        minHeight: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: _circle["default"],
      alt: "loading...",
      className: "player-content",
      onClick: this.pause,
      loading: loading,
      disabled: loading,
      onMouseOver: function onMouseOver() {
        return _this3.setState({
          onHoverPlay: false
        });
      },
      style: {
        marginTop: "5px"
      }
    }))) : /*#__PURE__*/_react["default"].createElement("span", {
      className: "mini-player-button"
    }, /*#__PURE__*/_react["default"].createElement(_ToolTip["default"], {
      key: "Pause",
      placement: "bottom",
      trigger: ["hover"],
      overlay: /*#__PURE__*/_react["default"].createElement("span", null, "Pause"),
      style: {
        minHeight: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      icon: "pause",
      type: "primary",
      size: "lg",
      shape: "circle",
      onClick: this.pause,
      loading: loading,
      disabled: loading,
      onMouseLeave: function onMouseLeave() {
        return _this3.setState({
          onHoverPlay: true
        });
      },
      style: {
        marginRight: "0px",
        marginTop: "5px"
      }
    }))))), /*#__PURE__*/_react["default"].createElement(_components["default"].ProgressTime, {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        // minWidth: "55px",
        // textAlign: "right",
        marginRight: "2px"
      }
    }, /*#__PURE__*/_react["default"].createElement(_TimeLabel["default"], {
      ms: currentTime
    })), " ", "/ ", /*#__PURE__*/_react["default"].createElement(_TimeLabel["default"], {
      ms: duration
    })), /*#__PURE__*/_react["default"].createElement(_components["default"].ProgressSpeed, null, /*#__PURE__*/_react["default"].createElement(_ToolTip["default"], {
      key: "flagCall",
      placement: "bottom",
      trigger: ["click"],
      visible: this.state.isSpeedTooltipVisible,
      onVisibleChange: this.onVisibleChangeForSelectSpeedTooltip,
      overlay: /*#__PURE__*/_react["default"].createElement("span", null, this.selectedSpeed())
    }, /*#__PURE__*/_react["default"].createElement(_ToolTip["default"], {
      key: "Adjust Speed",
      placement: "bottom",
      trigger: ["hover"],
      overlay: /*#__PURE__*/_react["default"].createElement("span", null, "Adjust Speed"),
      style: {
        minHeight: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement(_components["default"].ProgressSpeedText, null, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        minWidth: "25px",
        textAlign: "right"
      }
    }, this.state.speedValue), /*#__PURE__*/_react["default"].createElement("span", null, "x"), /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        marginTop: "5px",
        marginLeft: "1px"
      }
    }, /*#__PURE__*/_react["default"].createElement("svg", {
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.75 4.5L6 8.25L2.25 4.5",
      stroke: "#677791",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "caret-down"
    }))))))), /*#__PURE__*/_react["default"].createElement(_components["default"].ProgressIconStyle, null, /*#__PURE__*/_react["default"].createElement(_ToolTip["default"], {
      key: "Rewind",
      placement: "bottom",
      trigger: ["hover"],
      overlay: /*#__PURE__*/_react["default"].createElement("span", null, "Rewind"),
      style: {
        minHeight: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement("svg", {
      width: "16",
      height: "17",
      viewBox: "0 0 16 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      onClick: this.skipBackward,
      onMouseOver: function onMouseOver() {
        return _this3.setState({
          skipBackColor: "#262D38"
        });
      },
      onMouseLeave: function onMouseLeave() {
        return _this3.setState({
          skipBackColor: "#677791"
        });
      }
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M4.98975 6.48218H1.98975V3.48218",
      stroke: this.state.skipBackColor,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round" // id="skip-back-icon"

    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M4.11107 12.1391C4.88025 12.9083 5.86026 13.4321 6.92716 13.6443C7.99405 13.8565 9.09992 13.7476 10.1049 13.3313C11.1099 12.9151 11.9689 12.2101 12.5732 11.3056C13.1776 10.4012 13.5002 9.3378 13.5002 8.25C13.5002 7.16221 13.1776 6.09884 12.5732 5.19437C11.9689 4.2899 11.1099 3.58495 10.1049 3.16867C9.09992 2.75238 7.99405 2.64346 6.92716 2.85568C5.86026 3.0679 4.88025 3.59173 4.11107 4.36092L1.98975 6.48224",
      stroke: this.state.skipBackColor,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round" // id="skip-back-icon"

    })))), /*#__PURE__*/_react["default"].createElement(_components["default"].ProgressIconStyle, null, /*#__PURE__*/_react["default"].createElement(_ToolTip["default"], {
      key: "Fast Forward",
      placement: "bottom",
      trigger: ["hover"],
      overlay: /*#__PURE__*/_react["default"].createElement("span", null, "Fast Forward"),
      style: {
        minHeight: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement("svg", {
      width: "16",
      height: "17",
      viewBox: "0 0 16 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      onClick: this.skipForward,
      onMouseOver: function onMouseOver() {
        return _this3.setState({
          skipForwardColor: "#262D38"
        });
      },
      onMouseLeave: function onMouseLeave() {
        return _this3.setState({
          skipForwardColor: "#677791"
        });
      }
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M11.0103 6.48218H14.0103V3.48218",
      stroke: this.state.skipForwardColor,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M11.8891 12.1391C11.1199 12.9083 10.1399 13.4321 9.073 13.6443C8.0061 13.8565 6.90023 13.7476 5.89524 13.3313C4.89025 12.9151 4.03126 12.2101 3.42692 11.3056C2.82257 10.4012 2.5 9.3378 2.5 8.25C2.5 7.16221 2.82257 6.09884 3.42692 5.19437C4.03126 4.2899 4.89025 3.58495 5.89524 3.16867C6.90023 2.75238 8.0061 2.64346 9.073 2.85568C10.1399 3.0679 11.1199 3.59173 11.8891 4.36092L14.0104 6.48224",
      stroke: this.state.skipForwardColor,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })))), /*#__PURE__*/_react["default"].createElement(_components["default"].ProgressIconStyle, null, /*#__PURE__*/_react["default"].createElement(_ToolTip["default"], {
      key: "Skip to Next",
      placement: "bottom",
      trigger: ["hover"],
      overlay: /*#__PURE__*/_react["default"].createElement("span", null, "Skip to Next Hit"),
      style: {
        minHeight: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      "class": "next-hit-button-container"
    }, this.getHits(queries).length ? /*#__PURE__*/_react["default"].createElement(_Badge["default"], {
      dot: true
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      onClick: this.skipToNextHit,
      shape: "circle",
      icon: "history",
      size: "sm"
    })) : /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      shape: "circle",
      icon: "history",
      disabled: true,
      size: "sm"
    })))), /*#__PURE__*/_react["default"].createElement(_components["default"].ProgressIconStyle, {
      style: {
        whiteSpace: "nowrap",
        paddingLeft: "8px"
      }
    }, /*#__PURE__*/_react["default"].createElement(_ToolTip["default"], {
      key: "Volume",
      placement: "bottom",
      trigger: ["hover"],
      overlay: /*#__PURE__*/_react["default"].createElement("span", null, "Volume"),
      style: {
        minHeight: "auto"
      }
    }, volume === 0 ? /*#__PURE__*/_react["default"].createElement("svg", {
      width: "17",
      height: "17",
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      onClick: function onClick() {
        return _this3.clickOnVolume();
      }
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M3.5 3.06543L13.5 14.0654",
      stroke: "#677791",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M7.50928 4.50255L9.9999 2.56543V7.24224",
      stroke: "#677791",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10 10.2154V14.5654L5.5 11.0654H2.5C2.36739 11.0654 2.24021 11.0128 2.14645 10.919C2.05268 10.8252 2 10.698 2 10.5654V6.56543C2 6.43282 2.05268 6.30564 2.14645 6.21188C2.24021 6.11811 2.36739 6.06543 2.5 6.06543H6.22727",
      stroke: "#677791",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })) : /*#__PURE__*/_react["default"].createElement("svg", {
      width: "16",
      height: "17",
      viewBox: "0 0 16 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      onClick: function onClick() {
        return _this3.clickOnVolume();
      }
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5 10.75H2C1.86739 10.75 1.74021 10.6973 1.64645 10.6036C1.55268 10.5098 1.5 10.3826 1.5 10.25V6.25C1.5 6.11739 1.55268 5.99021 1.64645 5.89645C1.74021 5.80268 1.86739 5.75 2 5.75H5L9.5 2.25V14.25L5 10.75Z",
      stroke: volume > 0 ? "black" : "#677791",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5 5.75V10.75",
      stroke: volume > 0 ? "black" : "#677791",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))), /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
      style: {
        display: "inline-block",
        width: "110px",
        margin: "0",
        marginLeft: "10px",
        marginBottom: "5px"
      },
      min: 0,
      max: 100,
      step: 1,
      value: volume * 100,
      onChange: this.changeVolume // TODO: use a method call

    })), !isHostedApp && previousNextButtons({
      position: "absolute",
      right: "35px"
    })), /*#__PURE__*/_react["default"].createElement(_components["default"].ProgressSlider, {
      style: {
        display: "inline-flex",
        width: "100%"
      }
    }, /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
      horizontal: true,
      min: 0,
      max: duration,
      marks: this.getHitMarks(queries),
      value: currentTime,
      tipFormatter: this.renderTooltip,
      onChange: this.seek // TODO: use a method call
      ,
      style: {
        margin: 5,
        flex: 1
      },
      dotStyle: {
        display: "none"
      }
    }), !!queries.length && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_components["default"].ProgressEventMark, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      type: "clock-circle",
      theme: "filled"
    }), " ", hitCount)), /*#__PURE__*/_react["default"].createElement(_ToolTip["default"], {
      trigger: ["hover"],
      overlay: /*#__PURE__*/_react["default"].createElement("span", null, "Toggle speaker sentiment timeline"),
      style: {
        minHeight: "auto"
      }
    }, isTimeLineVisible ? /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        padding: "0 4px",
        flex: "none"
      }
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      shape: "circle",
      size: "sm",
      onClick: function onClick() {
        return setTimelineVisibility();
      },
      icon: "up",
      style: {
        border: "2px solid #677791"
      }
    })) : /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        padding: "0 4px",
        flex: "none"
      }
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      shape: "circle",
      size: "sm",
      onClick: function onClick() {
        return setTimelineVisibility();
      },
      icon: "down",
      style: {
        border: "2px solid #677791"
      }
    })))));
  };

  return ProgressControls;
}(_react["default"].PureComponent);

_defineProperty(ProgressControls, "contextType", _VoicebaseReactPlayerContext["default"]);

_defineProperty(ProgressControls, "defaultProps", {
  queries: []
});

ProgressControls.propTypes = process.env.NODE_ENV !== "production" ? {
  duration: _propTypes["default"].number,
  currentTime: _propTypes["default"].number,
  children: _propTypes["default"].node,
  mediaElement: _propTypes["default"].instanceOf(Element),
  mediaId: _propTypes["default"].string,
  messagesDuration: _propTypes["default"].number
} : {};

var _default = (0, _connectToMedia["default"])(mapStateToProps)(ProgressControls);

exports["default"] = _default;